export const FETCH_BIDDING = "FETCH_BIDDING";
export const BUY_WALLET = "BUY_WALLET";
export const CHANGE_STATUS_COST_PER_CLICK = "CHANGE_STATUS_COST_PER_CLICK";
export const ACCEPT_PRIZE = "ACCEPT_PRIZE";
export const VERIFY_BIDDING = "VERIFY_BIDDING";
